<ion-content class="ion-padding">
  <h2>Alle oder Meine</h2>
  <ion-radio-group [(ngModel)]="filterOne" (ngModelChange)="select(filterOne, 'filterOne')">
    @for (item of filterOneItems; track item) {
      <ion-item>
        <ion-icon [name]="item.icon" slot="start"></ion-icon>
        <ion-radio [value]="item.typeText">
          <ion-label>{{item.description}}</ion-label>
        </ion-radio>
      </ion-item>
    }
  </ion-radio-group>

  <div [class.visibleGroup]="filterOne == 'my'" [class.hiddenGroup]="filterOne != 'my'" style="transition: all 0.4s; overflow: hidden;">
    <h2>Bearbeiter u. Beobachter</h2>
    <ion-radio-group [(ngModel)]="filterObserver" (ngModelChange)="select(filterObserver, 'filterObserver')">
      @for (item of filterObserverItems; track item) {
        <ion-item>
          <ion-icon [name]="item.icon" slot="start"></ion-icon>
          <ion-radio [value]="item.typeText">
            <ion-label>{{item.description}}</ion-label>
          </ion-radio>
        </ion-item>
      }
    </ion-radio-group>
  </div>

  <h2>Status</h2>
  <ion-radio-group [(ngModel)]="filterTwo" (ngModelChange)="select(filterTwo, 'filterTwo')">
    @for (item of filterTwoItems; track item) {
      <ion-item>
        <ion-icon [name]="item.icon" slot="start"></ion-icon>
        <ion-radio [value]="item.typeText">
          <ion-label>{{item.description}}</ion-label>
        </ion-radio>
      </ion-item>
    }
  </ion-radio-group>
</ion-content>